import { useLang } from "@/lib/i18n";
import { Checkbox } from "@/components/ui/checkbox";
import { CheckCircle, Circle } from "@phosphor-icons/react";

export default function TimelineTab({ exp, setExp }) {
  const { t } = useLang();
  const steps = exp.timeline || [];

  const toggle = (idx) => {
    const next = steps.map((s, i) => {
      if (i !== idx) return s;
      const completed = !s.completed;
      return { ...s, completed, completed_at: completed ? new Date().toISOString() : null };
    });
    setExp({ ...exp, timeline: next });
  };

  return (
    <div className="space-y-6" data-testid="timeline-tab">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">{t.tab_timeline}</h2>
        <p className="text-slate-600 mt-1">Marca cada etapa del proceso al completarla. / Mark each stage as you complete it.</p>
      </div>

      <div className="bg-white border border-slate-200 p-6">
        <ol className="space-y-0">
          {steps.map((s, idx) => {
            const isLast = idx === steps.length - 1;
            return (
              <li key={s.key} className="relative pl-9 pb-6 last:pb-0" data-testid={`timeline-step-${s.key}`}>
                {!isLast && <span className="absolute left-[11px] top-7 bottom-0 w-px bg-slate-200" />}
                <button
                  data-testid={`toggle-step-${s.key}`}
                  onClick={() => toggle(idx)}
                  className="absolute left-0 top-1"
                >
                  {s.completed
                    ? <CheckCircle weight="fill" size={22} color="#f97316" />
                    : <Circle weight="duotone" size={22} color="#94a3b8" />}
                </button>
                <div className="flex items-baseline justify-between gap-4">
                  <div className={`font-semibold ${s.completed ? "text-slate-900" : "text-slate-700"}`}>
                    {t.timeline_steps[s.key] || s.key}
                  </div>
                  {s.completed_at && (
                    <span className="font-mono text-xs text-slate-500">
                      {new Date(s.completed_at).toLocaleDateString()}
                    </span>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
